import { render, staticRenderFns } from "./cookies.html?vue&type=template&id=7a70b90b&scoped=true&"
import script from "./cookies.js?vue&type=script&lang=js&"
export * from "./cookies.js?vue&type=script&lang=js&"
import style0 from "./cookies.scss?vue&type=style&index=0&id=7a70b90b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70b90b",
  null
  
)

export default component.exports